import { MaxDownstreamDatasourcesResultData, MaxDownstreamWorkbooksResultData } from '../types/MaxCountsResultData';

export function getMaxDownstreamDatasources(resultData: MaxDownstreamDatasourcesResultData | null): number | null {
  const maxDownstreamDatasources = resultData && resultData.maxDownstreamDatasources;
  const firstNode = maxDownstreamDatasources && maxDownstreamDatasources.nodes && maxDownstreamDatasources.nodes[0];
  const downstreamDatasourcesConnection = firstNode && firstNode.downstreamDatasourcesConnection;
  return downstreamDatasourcesConnection ? downstreamDatasourcesConnection.totalCount : null;
}

export function getMaxDownstreamWorkbooks(resultData: MaxDownstreamWorkbooksResultData | null): number | null {
  const maxDownstreamWorkbooks = resultData && resultData.maxDownstreamWorkbooks;
  const firstNode = maxDownstreamWorkbooks && maxDownstreamWorkbooks.nodes && maxDownstreamWorkbooks.nodes[0];
  const downstreamWorkbooksConnection = firstNode && firstNode.downstreamWorkbooksConnection;
  return downstreamWorkbooksConnection ? downstreamWorkbooksConnection.totalCount : null;
}
